import { render, staticRenderFns } from "./StudentExtraCard.vue?vue&type=template&id=91ae7694&"
import script from "./StudentExtraCard.vue?vue&type=script&lang=js&"
export * from "./StudentExtraCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports